import { render } from "./SuperAdminUsers.vue?vue&type=template&id=4a9eaf86&scoped=true"
import script from "./SuperAdminUsers.vue?vue&type=script&lang=js"
export * from "./SuperAdminUsers.vue?vue&type=script&lang=js"

import "./SuperAdminUsers.vue?vue&type=style&index=0&id=4a9eaf86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9eaf86"]])

export default __exports__